import { Box, CardMedia, Typography } from '@mui/material'
import React from 'react'
// import logo from './../../assets/Logo/logo.png'
const Logo = ({ logo, bio, isMobile }) => {
    return (
        <>
            <Box sx={{
                position: 'relative', zIndex: 2, width: '100%',
                mb: 1,
                textAlign: !isMobile && 'center', mt: 6
            }}>
                <CardMedia component={'img'} src={logo} className={'nav-logo'} sx={{
                    width: 'fit-content',
                    objectFit: 'none',
                    m: !isMobile && 'auto'
                }} />
                <Typography color='footer.link' fontWeight={500}
                    sx={{ position: 'relative', zIndex: 3, mt: 2 }} >
                    {bio}
                </Typography>
            </Box>
        </>
    )
}

export default Logo